import ProductCard from 'src/components/restructure/product/ProductCardV3/ProductCardV3'
import DktLoader from 'src/components/DktLoader/DktLoader'

import { useInfiniteProductList } from './useInfiniteProductList'

interface BreadcrumbItem {
  item: string
  name: string
  position: number
}

interface InfiniteProductListProps {
  breadcrumbList: BreadcrumbItem[]
}

export default function InfiniteProductList({
  breadcrumbList,
}: InfiniteProductListProps) {
  const { products, isLoading, sentinelRef, shouldRender } =
    useInfiniteProductList({ breadcrumbList })

  if (!shouldRender) {
    return null
  }

  return (
    <section className="w-full max-w-[1648px] mx-auto px-4 restructure-tablet:px-5 restructure-small-desktop:px-0 mt-10">
      <h2 className="font-inter text-[20px] md:text-[24px] font-semibold text-[#101010] mb-6">
        Você também pode gostar
      </h2>

      <ul className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {products.map((product, idx) => (
          <li key={`infinite-${product.productId}-${idx}`}>
            <ProductCard
              index={idx}
              product={product}
              shelfRef="vitrine: lista infinita pdp"
              productNameWrapper="h3"
            />
          </li>
        ))}
      </ul>

      {isLoading && (
        <div className="flex justify-center py-8">
          <DktLoader width={40} />
        </div>
      )}

      <div ref={sentinelRef} aria-hidden="true" style={{ height: 1 }} />
    </section>
  )
}
